export default __webpack_public_path__ + "ba7b898c9783116338a7c6adb2bbf452.png";